import { useTranslation } from "react-i18next";

export default function useArtifactContentType({ artifact }) {
	const { t } = useTranslation();

	switch (artifact?.contentType) {
		case "audio/wav":
		case "audio/mp3":
			return {
				text: t("audio", "Audio"),
				icon: "headphones",
			};
		case "application/epub+zip":
			return {
				text: "Epub",
				icon: "book",
			};
		default:
			return {
				text: t("unknown", "Unknown"),
				icon: "file",
			};
	}
}
